// extracted by mini-css-extract-plugin
export default {"pageContent":"PageContent_pageContent__fufmb","content":"PageContent_content__noPGZ","subHeader":"PageContent_subHeader__8NfGM","themeToggle":"PageContent_themeToggle__qXcQn"};